import React, { useState } from 'react';

// ── TERMS & CONDITIONS MODAL ──────────────────────────
function TermsModal({ onClose }) {
  return (
    <div
      onClick={e => e.target === e.currentTarget && onClose()}
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.75)', backdropFilter: 'blur(6px)', zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}
    >
      <div style={{ background: '#fff', borderRadius: 20, width: '100%', maxWidth: 680, maxHeight: '88vh', display: 'flex', flexDirection: 'column', boxShadow: '0 32px 80px rgba(0,0,0,0.3)', overflow: 'hidden' }}>
        <div style={{ background: '#C41230', padding: '22px 28px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0 }}>
          <div>
            <div style={{ fontSize: 20, fontWeight: 800, color: '#fff' }}>Terms & Conditions</div>
            <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.7)', marginTop: 3 }}>Rent355 · Tirana, Albania</div>
          </div>
          <button onClick={onClose} style={{ background: 'rgba(255,255,255,0.2)', border: 'none', borderRadius: 10, width: 36, height: 36, color: '#fff', fontSize: 18, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>✕</button>
        </div>
        <div style={{ overflowY: 'auto', padding: '28px 32px', flex: 1 }}>
          <style>{`
            .tc-section { margin-bottom: 28px; }
            .tc-h2 { font-size: 14px; font-weight: 800; color: #C41230; text-transform: uppercase; letter-spacing: 0.08em; margin-bottom: 12px; padding-bottom: 6px; border-bottom: 2px solid #FEE2E2; }
            .tc-p { font-size: 14px; color: #374151; line-height: 1.7; margin-bottom: 8px; }
            .tc-ul { padding-left: 18px; margin-bottom: 8px; }
            .tc-ul li { font-size: 14px; color: #374151; line-height: 1.7; margin-bottom: 4px; }
            .tc-table { width: 100%; border-collapse: collapse; margin-bottom: 12px; font-size: 13px; }
            .tc-table th { background: #F9FAFB; color: #111; font-weight: 700; padding: 8px 12px; text-align: left; border: 1px solid #E5E7EB; }
            .tc-table td { padding: 8px 12px; border: 1px solid #E5E7EB; color: #374151; }
            .tc-table tr:nth-child(even) td { background: #F9FAFB; }
          `}</style>
          <p className="tc-p" style={{ marginBottom: 24, color: '#6B7280', fontStyle: 'italic' }}>
            Welcome to Rent355! By accessing and using our services, you agree to comply with the terms and conditions outlined below. Please read these terms carefully to understand your rights and responsibilities when renting with us.
          </p>
          <div className="tc-section">
            <div className="tc-h2">✅ All Rates Include</div>
            <ul className="tc-ul">
              <li>Third Party Liability (TPL)</li>
              <li>VAT and all applicable taxes</li>
              <li>Breakdown assistance</li>
              <li>Road licensing fee</li>
              <li>Unlimited mileage</li>
            </ul>
          </div>
          <div className="tc-section">
            <div className="tc-h2">❌ Rates Do Not Include</div>
            <ul className="tc-ul">
              <li>Additional insurances – to be paid locally</li>
              <li>Collision Damage Waiver (CDW) with excess – to be paid locally</li>
              <li>Theft Waiver (TW) with excess – to be paid locally</li>
              <li>Additional extras – to be paid locally</li>
              <li>One-way hire – to be paid locally</li>
              <li>Cross border – to be paid locally</li>
              <li>Young / senior driver surcharge – to be paid locally</li>
            </ul>
          </div>
          <div className="tc-section">
            <div className="tc-h2">🪪 Driver's Requirements</div>
            <p className="tc-p">The renter must hold a valid passport and a European or International Driving License, issued at least one year before the rental.</p>
            <p className="tc-p">If the driving license is not in the Roman alphabet (Arabic, Greek, Russian, Chinese), an International Driving Permit is required along with the domestic license.</p>
            <table className="tc-table">
              <thead><tr><th>Requirement</th><th>Value</th></tr></thead>
              <tbody>
                <tr><td>Young driver surcharge</td><td>6 EUR / day</td></tr>
                <tr><td>Senior driver surcharge</td><td>6 EUR / day</td></tr>
                <tr><td>Minimum age (with surcharge)</td><td>21 years</td></tr>
                <tr><td>Minimum age (no surcharge)</td><td>25 years</td></tr>
                <tr><td>Maximum age (no surcharge)</td><td>67 years</td></tr>
                <tr><td>Maximum rental days</td><td>45 days</td></tr>
              </tbody>
            </table>
          </div>
          <div className="tc-section">
            <div className="tc-h2">💳 Security Deposit</div>
            <p className="tc-p">A deposit of <strong>300 EUR</strong> will be held on your card at pickup. If no charges are incurred, it will be released automatically.</p>
            <p className="tc-p">Deductible / excess: <strong>2,500 EUR</strong></p>
          </div>
          <div className="tc-section">
            <div className="tc-h2">⛽ Fuel Policy</div>
            <p className="tc-p">The vehicle will be provided with a full tank. The customer must return the car with the same amount of fuel. No refund for unused fuel.</p>
            <table className="tc-table">
              <thead><tr><th>Charge</th><th>Amount</th></tr></thead>
              <tbody>
                <tr><td>Missing petrol</td><td>2.50 EUR / liter</td></tr>
                <tr><td>Missing diesel</td><td>2.50 EUR / liter</td></tr>
                <tr><td>Administration fee</td><td>20 EUR</td></tr>
                <tr><td>Refueling mistake</td><td>500 EUR + 3 days rental</td></tr>
              </tbody>
            </table>
          </div>
          <div className="tc-section">
            <div className="tc-h2">🛡️ Insurance & Damage</div>
            <p className="tc-p"><strong>Collision Damage Waiver (CDW)</strong> is included. Deductible: 2,500 EUR. Police reports are mandatory in any accident.</p>
            <p className="tc-p"><strong>Theft Protection (TP)</strong> is NOT included. The renter must present the key to qualify for coverage.</p>
            <p className="tc-p"><strong>Full Damage Waiver (FDW)</strong> reduces excess to zero. A deposit of 300 EUR is still required. Voided if driving under influence.</p>
            <p className="tc-p" style={{ color: '#DC2626', fontWeight: 600 }}>Not covered: glasses, mirrors, tires, wheels, interior damage, clutch, vehicle underside.</p>
          </div>
          <div className="tc-section">
            <div className="tc-h2">➕ Extras</div>
            <table className="tc-table">
              <thead><tr><th>Extra</th><th>Per Day</th><th>Max per Rental</th></tr></thead>
              <tbody>
                <tr><td>Additional driver</td><td>5 EUR</td><td>60 EUR</td></tr>
                <tr><td>Baby / child / booster seat</td><td>5 EUR</td><td>50 EUR</td></tr>
              </tbody>
            </table>
          </div>
          <div className="tc-section">
            <div className="tc-h2">❌ Cancellation Policy</div>
            <ul className="tc-ul">
              <li><strong>Cancel 48+ hours before pickup:</strong> Full refund</li>
              <li><strong>Cancel less than 48 hours before pickup:</strong> Refund minus 50 EUR</li>
              <li><strong>Online payment under 50 EUR:</strong> No refund</li>
              <li>Amending extras may not be possible within 24 hours of pickup</li>
            </ul>
          </div>
          <div className="tc-section">
            <div className="tc-h2">🚫 No Show Policy</div>
            <p className="tc-p">If the client does not arrive within 2 hours after confirmed pickup time without notifying Rent355, the reservation may be classified as a no-show.</p>
          </div>
          <div className="tc-section">
            <div className="tc-h2">🚭 Smoking Policy</div>
            <p className="tc-p">Smoking is strictly prohibited in all Rent355 vehicles. Penalty: <strong>100 EUR</strong> per event.</p>
          </div>
          <div className="tc-section">
            <div className="tc-h2">🔑 Lost Keys</div>
            <table className="tc-table">
              <thead><tr><th>Event</th><th>Fee</th></tr></thead>
              <tbody>
                <tr><td>Administration fee</td><td>200 EUR</td></tr>
                <tr><td>Loss or badly damaged keys</td><td>450 EUR</td></tr>
              </tbody>
            </table>
          </div>
          <div className="tc-section">
            <div className="tc-h2">ℹ️ General Information</div>
            <p className="tc-p">Rent355 cannot guarantee a specific car model. The vehicle shown is for guidance only and may be substituted for a similar or upgraded vehicle at no extra cost.</p>
            <p className="tc-p">The vehicle has active GPS tracking that records movement at all times during the rental period.</p>
            <p className="tc-p">We accept Visa and Mastercard (credit and debit) for both payment and deposit.</p>
          </div>
          <div style={{ background: '#F9FAFB', borderRadius: 12, padding: '16px 20px', marginTop: 8, textAlign: 'center' }}>
            <p style={{ margin: 0, fontSize: 13, color: '#6B7280' }}>For questions contact us at <strong>info@rent355.com</strong> or <strong>+355682099501</strong></p>
            <p style={{ margin: '8px 0 0', fontSize: 12, color: '#9CA3AF' }}>Rent355 · Rruga Endri Keko, Tirana, Albania</p>
          </div>
        </div>
      </div>
    </div>
  );
}

// ── HOW TO BOOK MODAL ─────────────────────────────────
function HowToBookModal({ onClose }) {
  const steps = [
    { icon: '🚗', title: 'Browse Our Fleet', desc: 'Go to the Fleet page on rent355.com. Browse through our available cars — from economic to premium. Each card shows specs including seats, transmission, and fuel type.' },
    { icon: '📅', title: 'Click "Book Now"', desc: 'Found your car? Click the "Book Now" button on the car card. A booking form will open showing the vehicle you selected.' },
    { icon: '👤', title: 'Fill In Your Details', desc: 'Enter your full name, phone number, and email address. These details will be used to confirm your reservation.' },
    { icon: '📆', title: 'Select Your Dates & Times', desc: 'Choose your pickup and return date using the calendar. Select your preferred times (available 08:00 – 22:00). The total price will appear automatically.' },
    { icon: '💶', title: 'Review the Total Price', desc: 'Once dates are selected, the total price is calculated automatically including any seasonal pricing. Review before confirming.' },
    { icon: '✅', title: 'Confirm Your Booking', desc: 'Click "Confirm Booking" to submit. You will receive a confirmation on screen with your booking ID. Our team will contact you shortly.' },
    { icon: '📞', title: "We'll Be in Touch", desc: 'Our team will reach out via phone or WhatsApp to confirm availability and arrange pickup. Contact us at +355682099501 or info@rent355.com.' },
  ];

  return (
    <div
      onClick={e => e.target === e.currentTarget && onClose()}
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.75)', backdropFilter: 'blur(6px)', zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}
    >
      <div style={{ background: '#fff', borderRadius: 20, width: '100%', maxWidth: 580, maxHeight: '88vh', display: 'flex', flexDirection: 'column', boxShadow: '0 32px 80px rgba(0,0,0,0.3)', overflow: 'hidden' }}>
        <div style={{ background: '#0C0C0C', padding: '22px 28px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0 }}>
          <div>
            <div style={{ fontSize: 20, fontWeight: 800, color: '#fff' }}>How to Book</div>
            <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.5)', marginTop: 3 }}>Simple steps to reserve your car</div>
          </div>
          <button onClick={onClose} style={{ background: 'rgba(255,255,255,0.1)', border: 'none', borderRadius: 10, width: 36, height: 36, color: '#fff', fontSize: 18, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>✕</button>
        </div>
        <div style={{ overflowY: 'auto', padding: '24px 28px', flex: 1 }}>
          {steps.map((step, i) => (
            <div key={i} style={{ display: 'flex', gap: 16, marginBottom: i < steps.length - 1 ? 24 : 0, position: 'relative' }}>
              {i < steps.length - 1 && (
                <div style={{ position: 'absolute', left: 20, top: 44, width: 2, height: 'calc(100% + 0px)', background: '#F3F4F6', zIndex: 0 }}/>
              )}
              <div style={{ flexShrink: 0, width: 40, height: 40, background: '#C41230', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16, zIndex: 1, boxShadow: '0 4px 12px rgba(196,18,48,0.3)' }}>
                {step.icon}
              </div>
              <div style={{ flex: 1, paddingTop: 8 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
                  <span style={{ background: '#C41230', color: '#fff', borderRadius: 20, padding: '1px 8px', fontSize: 11, fontWeight: 800 }}>Step {i + 1}</span>
                  <div style={{ fontSize: 15, fontWeight: 700, color: '#111827' }}>{step.title}</div>
                </div>
                <p style={{ margin: 0, fontSize: 14, color: '#6B7280', lineHeight: 1.65 }}>{step.desc}</p>
              </div>
            </div>
          ))}
          <div style={{ marginTop: 28, background: '#0C0C0C', borderRadius: 14, padding: '20px 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16, flexWrap: 'wrap' }}>
            <div>
              <div style={{ fontSize: 14, fontWeight: 700, color: '#fff', marginBottom: 4 }}>Need help booking?</div>
              <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.5)' }}>We're available 08:00 – 22:00</div>
            </div>
            <a href="https://wa.me/355682099501" target="_blank" rel="noopener noreferrer"
              style={{ display: 'inline-flex', alignItems: 'center', gap: 8, background: '#25D366', color: '#fff', borderRadius: 10, padding: '10px 18px', fontSize: 13, fontWeight: 700, textDecoration: 'none' }}>
              <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
              WhatsApp Us
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

// ── FOOTER ────────────────────────────────────────────
export default function Footer() {
  const [showTerms, setShowTerms] = useState(false);
  const [showHowTo, setShowHowTo] = useState(false);

  return (
    <>
      {showTerms && <TermsModal onClose={() => setShowTerms(false)} />}
      {showHowTo && <HowToBookModal onClose={() => setShowHowTo(false)} />}

      <footer style={{ background: '#0C0C0C', color: '#fff', paddingTop: 56, paddingBottom: 0, marginTop: 80, fontFamily: 'var(--font-body)' }}>
        <div style={{ maxWidth: 1200, margin: '0 auto', padding: '0 24px' }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 40, paddingBottom: 48 }}>

            {/* Brand */}
            <div>
              <div style={{ marginBottom: 16 }}>
                <img src="/logo.png" alt="Rent355" style={{ height: 44, width: 'auto' }} />
              </div>
              <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.45)', lineHeight: 1.7, margin: '0 0 20px' }}>
                Premium car rental in Tirana, Albania. Drive with confidence across Albania.
              </p>
              <a href="https://wa.me/355682099501" target="_blank" rel="noopener noreferrer"
                style={{ display: 'inline-flex', alignItems: 'center', gap: 7, background: '#25D366', color: '#fff', borderRadius: 8, padding: '8px 16px', fontSize: 13, fontWeight: 700, textDecoration: 'none' }}>
                <svg width="14" height="14" fill="currentColor" viewBox="0 0 24 24"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
                WhatsApp Us
              </a>
            </div>

            {/* Quick Links */}
            <div>
              <div style={{ fontSize: 11, fontWeight: 800, color: '#C41230', textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: 18 }}>Quick Links</div>
              {[
                { label: 'Home' },
                { label: 'Our Fleet' },
                { label: 'Contact Us' },
                { label: 'How to Book', action: () => setShowHowTo(true) },
                { label: 'Terms & Conditions', action: () => setShowTerms(true) },
              ].map(({ label, action }) => (
                <div key={label} style={{ marginBottom: 10 }}>
                  <button onClick={action}
                    style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.55)', fontSize: 14, cursor: action ? 'pointer' : 'default', padding: 0, fontFamily: 'inherit', display: 'flex', alignItems: 'center', gap: 6, transition: 'color 0.15s' }}
                    onMouseEnter={e => action && (e.currentTarget.style.color = '#fff')}
                    onMouseLeave={e => action && (e.currentTarget.style.color = 'rgba(255,255,255,0.55)')}>
                    <span style={{ color: '#C41230', fontSize: 10 }}>▶</span> {label}
                  </button>
                </div>
              ))}
            </div>

            {/* Contact */}
            <div>
              <div style={{ fontSize: 11, fontWeight: 800, color: '#C41230', textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: 18 }}>Contact</div>
              {[
                { icon: '📍', text: 'Rruga Endri Keko, Tirana, Albania' },
                { icon: '📞', text: '+355 682 099 501' },
                { icon: '✉️', text: 'info@rent355.com' },
                { icon: '🕐', text: 'Available 08:00 – 22:00' },
              ].map(({ icon, text }) => (
                <div key={text} style={{ display: 'flex', gap: 10, marginBottom: 12 }}>
                  <span style={{ fontSize: 14, flexShrink: 0 }}>{icon}</span>
                  <span style={{ fontSize: 13, color: 'rgba(255,255,255,0.55)', lineHeight: 1.5 }}>{text}</span>
                </div>
              ))}
            </div>

            {/* Legal */}
            <div>
              <div style={{ fontSize: 11, fontWeight: 800, color: '#C41230', textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: 18 }}>Legal</div>
              <button onClick={() => setShowTerms(true)}
                style={{ display: 'block', background: 'rgba(196,18,48,0.1)', border: '1px solid rgba(196,18,48,0.3)', borderRadius: 10, padding: '12px 16px', color: '#fff', cursor: 'pointer', fontFamily: 'inherit', width: '100%', textAlign: 'left', marginBottom: 10, transition: 'all 0.15s' }}
                onMouseEnter={e => { e.currentTarget.style.background = 'rgba(196,18,48,0.2)'; e.currentTarget.style.borderColor = '#C41230'; }}
                onMouseLeave={e => { e.currentTarget.style.background = 'rgba(196,18,48,0.1)'; e.currentTarget.style.borderColor = 'rgba(196,18,48,0.3)'; }}>
                <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 3 }}>📄 Terms & Conditions</div>
                <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.4)' }}>Read our rental terms</div>
              </button>
              <button onClick={() => setShowHowTo(true)}
                style={{ display: 'block', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 10, padding: '12px 16px', color: '#fff', cursor: 'pointer', fontFamily: 'inherit', width: '100%', textAlign: 'left', transition: 'all 0.15s' }}
                onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.1)'; e.currentTarget.style.borderColor = 'rgba(255,255,255,0.2)'; }}
                onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.05)'; e.currentTarget.style.borderColor = 'rgba(255,255,255,0.1)'; }}>
                <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 3 }}>📋 How to Book</div>
                <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.4)' }}>Step-by-step guide</div>
              </button>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div style={{ borderTop: '1px solid rgba(255,255,255,0.07)', padding: '18px 24px' }}>
          <div style={{ maxWidth: 1200, margin: '0 auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
            <p style={{ margin: 0, fontSize: 12, color: 'rgba(255,255,255,0.3)' }}>
              © {new Date().getFullYear()} Rent355. All Rights Reserved. Tirana, Albania.
            </p>
            <div style={{ display: 'flex', gap: 16 }}>
              <button onClick={() => setShowTerms(true)} style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.3)', fontSize: 12, cursor: 'pointer', fontFamily: 'inherit', padding: 0, transition: 'color 0.15s' }}
                onMouseEnter={e => e.currentTarget.style.color = '#fff'}
                onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.3)'}>
                Terms & Conditions
              </button>
              <button onClick={() => setShowHowTo(true)} style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.3)', fontSize: 12, cursor: 'pointer', fontFamily: 'inherit', padding: 0, transition: 'color 0.15s' }}
                onMouseEnter={e => e.currentTarget.style.color = '#fff'}
                onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.3)'}>
                How to Book
              </button>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}